<template>
    <div class="mediaTop">
        <div class="top">
            <h1>Media library</h1>
        </div>
        <div class="inner flex flex-wrap justify-between items-center">
            <div class="left">
                <Filters
                    v-if="filters && typeToPick !== 'image'"
                    :filters="filters"
                    :active="activeFilter"
                    @changed="val => $emit('filterChanged', val)"
                />
            </div>
            <div class="right flex">
                <div class="searchHolder">
                    <SearchField
                        v-model="newSearch"
                        @keydown.enter.native="$emit('search', newSearch)"
                    />
                </div>
                <UploadButton
                    :type-to-pick="typeToPick"
                    @newUpload="media => $emit('newUpload', media)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import UploadButton from './UploadButton.vue';
import Filters from '../ui/Filters.vue';
import SearchField from '../ui/SearchField.vue';

export default {
    components: {
        UploadButton,
        Filters,
        SearchField,
    },
    props: {
        filters: {
            type: Array,
            default: null,
        },
        activeFilter: {
            type: String,
            default: null,
        },
        currentSearch: {
            type: String,
            default: null,
        },
        typeToPick: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        newSearch: null,
    }),
};
</script>

<style lang="postcss" scoped>
.mediaTop,
.top {
    margin-bottom: 25px;
}
.searchHolder {
    width: 330px;
    padding-right: 25px;
    @media (--laptop) {
        width: 280px;
    }
}
</style>
